import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📗',
  title: 'Tomo 1 — El Módulo Semilla',
  subtitle: 'Tu Primera Casa: 35m² que Cambian Todo',
  desc: 'Planta completa con estar-comedor, dormitorio, baño y cocina-lavadero. Diseñada para construirse en etapas — sin demoler nada cuando ampliés.'
}, {
  icon: '📘',
  title: 'Tomo 2 — La Primera Expansión',
  subtitle: 'De 35m² a 55m²: Tu Segundo Dormitorio Sin Demoler Nada',
  desc: 'Cómo ampliar el Módulo Semilla de manera inteligente. Un segundo dormitorio y más espacio sin interrumpir la vida en la casa.'
}, {
  icon: '📙',
  title: 'Tomo 3 — La Vivienda Familiar',
  subtitle: '72m²: El Segundo Baño que Cambia la Vida Familiar',
  desc: 'El salto de calidad más importante de la serie. Dos baños, cocina independiente, lavadero separado y espacio real para una familia de cuatro.'
}, {
  icon: '📕',
  title: 'Tomo 4 — La Vivienda Premium',
  subtitle: '95m²: Suite Matrimonial, 3 Dormitorios y Terminaciones de Valor',
  desc: 'La casa definitiva de la serie. Suite con baño en suite y vestidor, tres dormitorios y terminaciones que aumentan el valor del inmueble.'
}, {
  icon: '📒',
  title: 'Tomo 5 — El Kit del Corralón',
  subtitle: 'Cómputo y Presupuesto Exacto para Tu Obra',
  desc: 'El tomo que te protege de los presupuestos inflados. Cómo calcular exactamente cuánto material necesitás — antes de ir al corralón.'
}, {
  icon: '📓',
  title: 'Tomo 6 — El Manual de Obra',
  subtitle: 'Supervisá Tu Construcción Sin Ser Experto',
  desc: 'Cómo controlar el avance, verificar la calidad y evitar que te cobren lo que no corresponde.'
}];
const includes = ['Plano completo con medidas reales', 'Lista de materiales lista para el corralón', 'Presupuesto orientativo actualizado', 'Orden de construcción por etapa', 'Errores más comunes y cómo evitarlos', 'Decisiones de diseño explicadas en lenguaje de propietario', 'Conexión con los tomos anteriores y siguientes', '100% adaptado al mercado argentino actual'];
export function ProductOverview() {
  return <section id="sistema" className="py-20 bg-beige" data-id="element-293">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="text-center mb-16" data-id="element-295">
          <div className="inline-flex items-center justify-center gap-2 mb-4" data-id="element-296">
            <span className="text-2xl" data-id="element-297">🏆</span>
            <h2 className="text-sm font-bold tracking-widest text-gold uppercase" data-id="element-298">
              ZENTRAL PRO™ — PACK CI 6×6
            </h2>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-299">
            6 Tomos + 4 Bonos — 35m² → 95m²
          </h3>
          <p className="text-xl text-gray-600" data-id="element-300">
            Todo resuelto. En etapas. Para Argentina.
          </p>
        </div>

        {/* Journey Map / Pills */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-16" data-id="element-301">
          {['T1 35m²', 'T2 55m²', 'T3 72m²', 'T4 95m²', 'T5 Corralón', 'T6 Obra'].map((pill, i) => <div key={i} className="bg-white border border-beige-dark px-4 py-2 rounded-full text-sm font-semibold text-charcoal shadow-sm flex items-center gap-2" data-id="element-302">
              <span className="w-2 h-2 rounded-full bg-gold" data-id="element-303"></span>
              {pill}
            </div>)}
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-beige-dark overflow-hidden" data-id="element-304">
          <div className="bg-charcoal text-white p-8 text-center" data-id="element-305">
            <h4 className="text-2xl font-serif font-bold mb-2" data-id="element-306">
              6 TOMOS COMPLETOS
            </h4>
            <p className="text-gold font-medium" data-id="element-307">
              🏗️ 35m² → 95m² — EL SISTEMA COMPLETO POR ETAPAS
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-308">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-309">
              {tomos.map((tomo, i) => <div key={i} className="flex gap-4" data-id="element-310">
                  <div className="text-4xl shrink-0" data-id="element-311">{tomo.icon}</div>
                  <div data-id="element-312">
                    <h5 className="font-bold text-lg text-charcoal mb-1" data-id="element-313">
                      {tomo.title}
                    </h5>
                    <p className="text-gold font-medium text-sm mb-2" data-id="element-314">
                      {tomo.subtitle}
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-315">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-16 pt-12 border-t border-beige-dark" data-id="element-316">
              <h5 className="font-serif font-bold text-xl mb-6 text-center" data-id="element-317">
                Cada tomo incluye:
              </h5>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-318">
                {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-319">
                    <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-320" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-321">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}